/**
 * Smartfactor API
 * API for Smartfactor System
 *
 * The version of the OpenAPI document: 0.4.297
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { RoadOccupationAppEntityRoadOccupationItemRead } from '../model/roadOccupationAppEntityRoadOccupationItemRead';
// @ts-ignore
import { RoadOccupationAppEntityRoadOccupationRead } from '../model/roadOccupationAppEntityRoadOccupationRead';
// @ts-ignore
import { RoadOccupationAppEntityRoadOccupationWrite } from '../model/roadOccupationAppEntityRoadOccupationWrite';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


export interface DeleteRoadOccupationRoadOccupationItemRequestParams {
    id: string;
}

export interface GetRoadOccupationCollectionRoadOccupationCollectionRequestParams {
    id?: string;
    id2?: Array<string>;
    city?: string;
    city2?: Array<string>;
    purpose?: string;
    purpose2?: Array<string>;
    locationDecisionNumber?: string;
    locationDecisionNumber2?: Array<string>;
    locationDecisionDate?: string;
    locationDecisionDate2?: string;
    typeOfFailure?: string;
    typeOfFailure2?: Array<string>;
    surfaceViolation?: string;
    surfaceViolation2?: Array<string>;
    workPurpose?: string;
    workPurpose2?: Array<string>;
    street?: string;
    street2?: Array<string>;
    agreementNumber?: string;
    agreementNumber2?: Array<string>;
    agreementDate?: string;
    agreementDate2?: string;
    deviceType?: string;
    deviceType2?: Array<string>;
    createdAt?: string;
    createdAt2?: string;
    updatedAt?: string;
    updatedAt2?: string;
    deletedAt?: string;
    deletedAt2?: string;
    /** The collection page number */
    page?: number;
    /** The number of items per page */
    itemsPerPage?: number;
    /** Enable or disable pagination */
    pagination?: boolean;
}

export interface GetRoadOccupationItemRoadOccupationItemRequestParams {
    id: string;
}

export interface PatchRoadOccupationRoadOccupationItemRequestParams {
    id: string;
    /** The updated RoadOccupation resource */
    roadOccupation?: RoadOccupationAppEntityRoadOccupationWrite;
}

export interface PostRoadOccupationRoadOccupationCollectionRequestParams {
    /** The new RoadOccupation resource */
    roadOccupation?: RoadOccupationAppEntityRoadOccupationWrite;
}


@Injectable({
  providedIn: 'root'
})
export class RoadOccupationService {

    protected basePath = '/system';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string|string[], @Optional() configuration: Configuration) {
        if (configuration) {
            this.configuration = configuration;
        }
        if (typeof this.configuration.basePath !== 'string') {
            const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
            if (firstBasePath != undefined) {
                basePath = firstBasePath;
            }

            if (typeof basePath !== 'string') {
                basePath = this.basePath;
            }
            this.configuration.basePath = basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }


    // @ts-ignore
    private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
        if (typeof value === "object" && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        } else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }

    private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
        if (value == null) {
            return httpParams;
        }

        if (typeof value === "object") {
            if (Array.isArray(value)) {
                (value as any[]).forEach( elem => httpParams = this.addToHttpParamsRecursive(httpParams, elem, key));
            } else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
                } else {
                   throw Error("key may not be null if value is Date");
                }
            } else {
                Object.keys(value).forEach( k => httpParams = this.addToHttpParamsRecursive(
                    httpParams, value[k], key != null ? `${key}.${k}` : k));
            }
        } else if (key != null) {
            httpParams = httpParams.append(key, value);
        } else {
            throw Error("key may not be null if value is not object or array");
        }
        return httpParams;
    }

    /**
     * Removes the RoadOccupation resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteRoadOccupationRoadOccupationItem(requestParameters?: DeleteRoadOccupationRoadOccupationItemRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any>;
    public deleteRoadOccupationRoadOccupationItem(requestParameters?: DeleteRoadOccupationRoadOccupationItemRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpResponse<any>>;
    public deleteRoadOccupationRoadOccupationItem(requestParameters?: DeleteRoadOccupationRoadOccupationItemRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<HttpEvent<any>>;
    public deleteRoadOccupationRoadOccupationItem(requestParameters?: DeleteRoadOccupationRoadOccupationItemRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteRoadOccupationRoadOccupationItem.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road_occupations/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves the collection of RoadOccupation resources.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRoadOccupationCollectionRoadOccupationCollection(requestParameters?: GetRoadOccupationCollectionRoadOccupationCollectionRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<Array<RoadOccupationAppEntityRoadOccupationRead>>;
    public getRoadOccupationCollectionRoadOccupationCollection(requestParameters?: GetRoadOccupationCollectionRoadOccupationCollectionRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<Array<RoadOccupationAppEntityRoadOccupationRead>>>;
    public getRoadOccupationCollectionRoadOccupationCollection(requestParameters?: GetRoadOccupationCollectionRoadOccupationCollectionRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<Array<RoadOccupationAppEntityRoadOccupationRead>>>;
    public getRoadOccupationCollectionRoadOccupationCollection(requestParameters?: GetRoadOccupationCollectionRoadOccupationCollectionRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        const id2 = requestParameters?.id2;
        const city = requestParameters?.city;
        const city2 = requestParameters?.city2;
        const purpose = requestParameters?.purpose;
        const purpose2 = requestParameters?.purpose2;
        const locationDecisionNumber = requestParameters?.locationDecisionNumber;
        const locationDecisionNumber2 = requestParameters?.locationDecisionNumber2;
        const locationDecisionDate = requestParameters?.locationDecisionDate;
        const locationDecisionDate2 = requestParameters?.locationDecisionDate2;
        const typeOfFailure = requestParameters?.typeOfFailure;
        const typeOfFailure2 = requestParameters?.typeOfFailure2;
        const surfaceViolation = requestParameters?.surfaceViolation;
        const surfaceViolation2 = requestParameters?.surfaceViolation2;
        const workPurpose = requestParameters?.workPurpose;
        const workPurpose2 = requestParameters?.workPurpose2;
        const street = requestParameters?.street;
        const street2 = requestParameters?.street2;
        const agreementNumber = requestParameters?.agreementNumber;
        const agreementNumber2 = requestParameters?.agreementNumber2;
        const agreementDate = requestParameters?.agreementDate;
        const agreementDate2 = requestParameters?.agreementDate2;
        const deviceType = requestParameters?.deviceType;
        const deviceType2 = requestParameters?.deviceType2;
        const createdAt = requestParameters?.createdAt;
        const createdAt2 = requestParameters?.createdAt2;
        const updatedAt = requestParameters?.updatedAt;
        const updatedAt2 = requestParameters?.updatedAt2;
        const deletedAt = requestParameters?.deletedAt;
        const deletedAt2 = requestParameters?.deletedAt2;
        const page = requestParameters?.page;
        const itemsPerPage = requestParameters?.itemsPerPage;
        const pagination = requestParameters?.pagination;

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (id !== undefined && id !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>id, 'id');
        }
        if (id2) {
            id2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'id[]');
            })
        }
        if (city !== undefined && city !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>city, 'city');
        }
        if (city2) {
            city2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'city[]');
            })
        }
        if (purpose !== undefined && purpose !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>purpose, 'purpose');
        }
        if (purpose2) {
            purpose2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'purpose[]');
            })
        }
        if (locationDecisionNumber !== undefined && locationDecisionNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>locationDecisionNumber, 'locationDecisionNumber');
        }
        if (locationDecisionNumber2) {
            locationDecisionNumber2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'locationDecisionNumber[]');
            })
        }
        if (locationDecisionDate !== undefined && locationDecisionDate !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>locationDecisionDate, 'locationDecisionDate');
        }
        if (locationDecisionDate2 !== undefined && locationDecisionDate2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>locationDecisionDate2, 'locationDecisionDate[]');
        }
        if (typeOfFailure !== undefined && typeOfFailure !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>typeOfFailure, 'typeOfFailure');
        }
        if (typeOfFailure2) {
            typeOfFailure2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'typeOfFailure[]');
            })
        }
        if (surfaceViolation !== undefined && surfaceViolation !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>surfaceViolation, 'surfaceViolation');
        }
        if (surfaceViolation2) {
            surfaceViolation2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'surfaceViolation[]');
            })
        }
        if (workPurpose !== undefined && workPurpose !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>workPurpose, 'workPurpose');
        }
        if (workPurpose2) {
            workPurpose2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'workPurpose[]');
            })
        }
        if (street !== undefined && street !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>street, 'street');
        }
        if (street2) {
            street2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'street[]');
            })
        }
        if (agreementNumber !== undefined && agreementNumber !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>agreementNumber, 'agreementNumber');
        }
        if (agreementNumber2) {
            agreementNumber2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'agreementNumber[]');
            })
        }
        if (agreementDate !== undefined && agreementDate !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>agreementDate, 'agreementDate');
        }
        if (agreementDate2 !== undefined && agreementDate2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>agreementDate2, 'agreementDate[]');
        }
        if (deviceType !== undefined && deviceType !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>deviceType, 'deviceType');
        }
        if (deviceType2) {
            deviceType2.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'deviceType[]');
            })
        }
        if (createdAt !== undefined && createdAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>createdAt, 'createdAt');
        }
        if (createdAt2 !== undefined && createdAt2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>createdAt2, 'createdAt[]');
        }
        if (updatedAt !== undefined && updatedAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>updatedAt, 'updatedAt');
        }
        if (updatedAt2 !== undefined && updatedAt2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>updatedAt2, 'updatedAt[]');
        }
        if (deletedAt !== undefined && deletedAt !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>deletedAt, 'deletedAt');
        }
        if (deletedAt2 !== undefined && deletedAt2 !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>deletedAt2, 'deletedAt[]');
        }
        if (page !== undefined && page !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>page, 'page');
        }
        if (itemsPerPage !== undefined && itemsPerPage !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>itemsPerPage, 'itemsPerPage');
        }
        if (pagination !== undefined && pagination !== null) {
          localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
            <any>pagination, 'pagination');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road_occupations`;
        return this.httpClient.request<Array<RoadOccupationAppEntityRoadOccupationRead>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieves a RoadOccupation resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRoadOccupationItemRoadOccupationItem(requestParameters?: GetRoadOccupationItemRoadOccupationItemRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<RoadOccupationAppEntityRoadOccupationItemRead>;
    public getRoadOccupationItemRoadOccupationItem(requestParameters?: GetRoadOccupationItemRoadOccupationItemRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<RoadOccupationAppEntityRoadOccupationItemRead>>;
    public getRoadOccupationItemRoadOccupationItem(requestParameters?: GetRoadOccupationItemRoadOccupationItemRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<RoadOccupationAppEntityRoadOccupationItemRead>>;
    public getRoadOccupationItemRoadOccupationItem(requestParameters?: GetRoadOccupationItemRoadOccupationItemRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getRoadOccupationItemRoadOccupationItem.');
        }

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road_occupations/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<RoadOccupationAppEntityRoadOccupationItemRead>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Updates the RoadOccupation resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchRoadOccupationRoadOccupationItem(requestParameters?: PatchRoadOccupationRoadOccupationItemRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<RoadOccupationAppEntityRoadOccupationRead>;
    public patchRoadOccupationRoadOccupationItem(requestParameters?: PatchRoadOccupationRoadOccupationItemRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<RoadOccupationAppEntityRoadOccupationRead>>;
    public patchRoadOccupationRoadOccupationItem(requestParameters?: PatchRoadOccupationRoadOccupationItemRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<RoadOccupationAppEntityRoadOccupationRead>>;
    public patchRoadOccupationRoadOccupationItem(requestParameters?: PatchRoadOccupationRoadOccupationItemRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling patchRoadOccupationRoadOccupationItem.');
        }
        const roadOccupation = requestParameters?.roadOccupation;

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/merge-patch+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road_occupations/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<RoadOccupationAppEntityRoadOccupationRead>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: roadOccupation,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Creates a RoadOccupation resource.
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postRoadOccupationRoadOccupationCollection(requestParameters?: PostRoadOccupationRoadOccupationCollectionRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<RoadOccupationAppEntityRoadOccupationRead>;
    public postRoadOccupationRoadOccupationCollection(requestParameters?: PostRoadOccupationRoadOccupationCollectionRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpResponse<RoadOccupationAppEntityRoadOccupationRead>>;
    public postRoadOccupationRoadOccupationCollection(requestParameters?: PostRoadOccupationRoadOccupationCollectionRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<HttpEvent<RoadOccupationAppEntityRoadOccupationRead>>;
    public postRoadOccupationRoadOccupationCollection(requestParameters?: PostRoadOccupationRoadOccupationCollectionRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'application/ld+json' | 'text/html' | 'application/octet-stream', context?: HttpContext}): Observable<any> {
        const roadOccupation = requestParameters?.roadOccupation;

        let localVarHeaders = this.defaultHeaders;

        let localVarCredential: string | undefined;
        // authentication (apiKey) required
        localVarCredential = this.configuration.lookupCredential('apiKey');
        if (localVarCredential) {
            localVarHeaders = localVarHeaders.set('Authorization', localVarCredential);
        }

        let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
        if (localVarHttpHeaderAcceptSelected === undefined) {
            // to determine the Accept header
            const httpHeaderAccepts: string[] = [
                'application/json',
                'application/ld+json',
                'text/html',
                'application/octet-stream'
            ];
            localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        }
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        let localVarHttpContext: HttpContext | undefined = options && options.context;
        if (localVarHttpContext === undefined) {
            localVarHttpContext = new HttpContext();
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/ld+json',
            'text/html',
            'application/octet-stream'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/road_occupations`;
        return this.httpClient.request<RoadOccupationAppEntityRoadOccupationRead>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: roadOccupation,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
